import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
export const fetchConfig = createAsyncThunk('config/fetchConfig', async () => {
  const axiosInstance = require('../axios_instance').default || require('../axios_instance');
  const response = await axiosInstance.get('/v1/config/recupera');
  return response.data;
});

const configSlice = createSlice({
  name: 'config',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchConfig.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default configSlice.reducer;
